import * as Sentry from "@sentry/react";

export function beforeSend(
    event: Sentry.ErrorEvent,
): Sentry.ErrorEvent | null {
    const activeSpan = Sentry.getActiveSpan();
    const sessionId = sessionStorage.getItem("sessionId") || "";

    if (activeSpan) {
        const spanContext = activeSpan.spanContext();
        if (spanContext.traceId) {
            event.tags = event.tags || {};
            if (!event.tags.apiTraceId) {
                event.tags.apiTraceId = spanContext.traceId;
            }
            if (spanContext.spanId) {
                event.contexts = event.contexts || {};
                event.contexts.trace = {
                    trace_id: spanContext.traceId,
                    span_id: spanContext.spanId,
                };
            }
        }
    }

    if (sessionId) {
        event.tags = event.tags || {};
        event.tags.sessionId = sessionId;
        event.user = event.user || {};
        event.user.id = sessionId;
    }

    event.extra = event.extra || {};
    event.extra.service = "webapp";

    return event;
}

